import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, ErrorTemplate, ErrorTemplateCode, Progress } from 'web-library';
import { useParams } from 'react-router-dom';
import ErrorPageTitle from '../../components/errors/ErrorPageTitle';
import { useGetNotificationAcknowledgementStatus } from '../../api-refactored/notifications/useGetNotificationAcknowledgementStatus';
import { usePutNotificationAcknowledgementStatus } from '../../api-refactored/notifications/usePutNotificationAcknowledgementStatus';

const NotificationAcknowledgement = () => {
  const { t } = useTranslation();
  const { uuid } = useParams<{ uuid: string }>();
  const [message, setMessage] = useState<string>('');

  const {
    isLoading: isLoadingAcknowledgementStatusModel,
  } = useGetNotificationAcknowledgementStatus({
    uuid,
    onSuccess: (data) => {
      if (data.acknowledged) {
        setMessage('components->>NotificationAcknowledgement.InvalidLink');
      } else {
        putAcknowledgementStatus();
      }
    },
    onError: () => {
      setMessage('components->>NotificationAcknowledgement.InvalidLink');
    },
  });

  const {
    mutate: putAcknowledgementStatus,
    isLoading: isLoadingPutNotifiationAcknowledgement,
  } = usePutNotificationAcknowledgementStatus({
    uuid,
    onSuccess: () => {
      setMessage('components->>NotificationAcknowledgement.SuccessfullyAcknowledged');
    },
  });

  if (isLoadingAcknowledgementStatusModel || isLoadingPutNotifiationAcknowledgement) {
    return (
      <ContentTemplate>
        <Progress color="secondary" />
      </ContentTemplate>
    );
  }

  return (
    <ErrorTemplate
      errorCode={'generic' as ErrorTemplateCode}
      title={<ErrorPageTitle label={t(message)} />}
      subtitle=""
    />
  );
};

export default NotificationAcknowledgement;
